import { useUiStore } from '@/i18n';
import { useT } from '@/i18n/use-t';
import { changeFrom } from '@/lib/compare';
import { signedPercent } from '@/lib/format';

/** A figure against the period just before (ADR-108), worded for a metric card. */
export function useVersus() {
  const t = useT();
  const locale = useUiStore((state) => state.locale);
  return (current: number, previous: number | undefined) => {
    if (previous === undefined) return undefined;
    const change = changeFrom(current, previous);
    return {
      direction: change.direction,
      text:
        change.percent === null
          ? change.direction === 'flat'
            ? t('sameAsPrevious')
            : t('newVsPrevious')
          : change.percent === 0
            ? t('sameAsPrevious')
            : t('vsPrevious', { change: signedPercent(change.percent, locale) }),
    };
  };
}
